"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGRICULTURE_OPS_BOOTSTRAP_SEED = void 0;
exports.AGRICULTURE_OPS_BOOTSTRAP_SEED = {
    livestock: [
        {
            id: "HRD-001",
            tag: "HRD-001",
            type: "Cattle",
            breed: "Nguni",
            count: 45,
            health: "healthy",
            trackerId: "TRK-201",
            trackerStatus: "active",
            paddock: "North Paddock",
            lastSeen: "2026-03-21T06:30:00Z",
            description: "Nguni breeding herd monitored for weight, rumination, and fence-crossing compliance.",
            farmer: {
                name: "Thabo Ndlovu",
                role: "Farm Owner",
                contact: "+27 82 555 1234",
                email: "thabo@greenvalley.test",
                avatarInitials: "TN",
                organization: "Green Valley Farm",
            },
            assignedDriver: {
                name: "Sipho Mokoena",
                role: "Livestock Transport Driver",
                contact: "+27 72 014 8876",
                email: "sipho.mokoena@greenvalley.test",
                avatarInitials: "SM",
                organization: "Green Valley Logistics",
            },
            transportUnit: "Isuzu NMR Livestock Carrier",
            lastHealthCheck: "2026-03-19",
            metrics: [
                { label: "Average weight", value: "385 kg", helper: "7-day moving average", tone: "emerald" },
                { label: "Body condition", value: "4.2 / 5", helper: "Veterinary score", tone: "emerald" },
                { label: "Vaccination cover", value: "98%", helper: "Program completion", tone: "cyan" },
                { label: "Mortality rate", value: "1.2%", helper: "Season to date", tone: "amber" },
            ],
            telematics: [
                { label: "Tracker coverage", value: "96%", helper: "Herd-wide connectivity", tone: "emerald" },
                { label: "Daily movement", value: "8.4 km", helper: "Average herd path", tone: "cyan" },
                { label: "Fence compliance", value: "99.1%", helper: "Geofence exits", tone: "emerald" },
                { label: "Battery health", value: "82%", helper: "Tracker cluster median", tone: "amber" },
            ],
            alerts: [
                {
                    id: "alert-hrd-001-1",
                    title: "Gate opened after curfew",
                    message: "North paddock service gate opened at 22:14 and re-closed after 6 minutes.",
                    severity: "warning",
                    createdAt: "2026-03-20T22:14:00Z",
                },
            ],
            movementHistory: [
                {
                    id: "mov-hrd-001-1",
                    at: "2026-03-20T10:15:00Z",
                    location: "North Paddock",
                    event: "Rotational grazing shift completed",
                    distanceKm: 1.8,
                },
                {
                    id: "mov-hrd-001-2",
                    at: "2026-03-18T07:45:00Z",
                    location: "Holding lane",
                    event: "Vet inspection movement",
                    distanceKm: 0.6,
                },
            ],
            healthLogs: [
                {
                    id: "health-hrd-001-1",
                    at: "2026-03-19",
                    status: "Healthy",
                    treatment: "Routine mineral dose",
                    owner: "Dr. N. Khumalo",
                    note: "Condition stable with improved average weight gain.",
                },
            ],
            timeline: [
                {
                    id: "hrd-001-1",
                    at: "2026-03-21T06:30:00Z",
                    title: "Morning location sync completed",
                    actorName: "Tracker network",
                    detail: "45/45 collars reported within 90 seconds.",
                    tone: "cyan",
                },
                {
                    id: "hrd-001-2",
                    at: "2026-03-19T13:40:00Z",
                    title: "Vet health review completed",
                    actorName: "Dr. N. Khumalo",
                    detail: "No respiratory or lameness markers observed.",
                    tone: "emerald",
                },
            ],
            comments: [
                {
                    id: "hrd-001-comment-1",
                    author: "Vet Operations",
                    message: "Vaccination register updated and synced with March herd record.",
                    createdAt: "2026-03-19T14:00:00Z",
                    kind: "comment",
                },
            ],
            polygon: [
                { lat: -25.7461, lng: 28.1881 },
                { lat: -25.744, lng: 28.1922 },
                { lat: -25.7399, lng: 28.1894 },
                { lat: -25.7418, lng: 28.1847 },
            ],
            markers: [
                { lat: -25.7437, lng: 28.1886, label: "Water Point 2", kind: "sensor" },
                { lat: -25.7428, lng: 28.1897, label: "Herd centroid", kind: "livestock" },
            ],
            linkedWorkOrderIds: ["WO-0038"],
            linkedProjectIds: ["PRJ-002"],
        },
        {
            id: "HRD-003",
            tag: "HRD-003",
            type: "Sheep",
            breed: "Merino",
            count: 120,
            health: "vaccination-due",
            trackerId: "TRK-203",
            trackerStatus: "active",
            paddock: "South Field",
            lastSeen: "2026-03-21T05:50:00Z",
            description: "Merino flock managed for wool quality, lambing performance, and seasonal vaccination schedule.",
            farmer: {
                name: "Pieter van Zyl",
                role: "Flock Manager",
                contact: "+27 84 555 9012",
                email: "pieter@woolhaven.test",
                avatarInitials: "PV",
                organization: "Woolhaven",
            },
            assignedDriver: null,
            transportUnit: "ATV Herd Unit",
            lastHealthCheck: "2026-03-10",
            metrics: [
                { label: "Lambing rate", value: "92%", helper: "Season target 90%", tone: "emerald" },
                { label: "Wool grade", value: "A", helper: "Last classing result", tone: "cyan" },
                { label: "Vaccination due", value: "120 head", helper: "Clostridial", tone: "amber" },
            ],
            telematics: [
                { label: "Boundary compliance", value: "98.7%", helper: "Weekly average", tone: "emerald" },
                { label: "Night rest pattern", value: "Stable", helper: "No anomaly clusters", tone: "cyan" },
                { label: "Shearing readiness", value: "14 days", helper: "Based on fleece growth", tone: "violet" },
            ],
            alerts: [
                {
                    id: "alert-hrd-003-1",
                    title: "Vaccination campaign due",
                    message: "South flock vaccination window opens in 48 hours.",
                    severity: "warning",
                    createdAt: "2026-03-21T04:00:00Z",
                },
            ],
            movementHistory: [
                {
                    id: "mov-hrd-003-1",
                    at: "2026-03-20T13:20:00Z",
                    location: "South Field",
                    event: "Shade-line relocation",
                    distanceKm: 0.9,
                },
            ],
            healthLogs: [
                {
                    id: "health-hrd-003-1",
                    at: "2026-03-10",
                    status: "Vaccination due",
                    owner: "Pieter van Zyl",
                    note: "Prepare flock for clostridial campaign and wool inspection.",
                },
            ],
            timeline: [
                {
                    id: "hrd-003-1",
                    at: "2026-03-21T04:00:00Z",
                    title: "Campaign reminder issued",
                    actorName: "Animal health engine",
                    detail: "Vaccination workflow pushed to livestock foreman queue.",
                    tone: "amber",
                },
            ],
            comments: [
                {
                    id: "hrd-003-comment-1",
                    author: "Livestock Foreman",
                    message: "Drafted labour and crush-pen plan for vaccination day.",
                    createdAt: "2026-03-21T05:05:00Z",
                    kind: "comment",
                },
            ],
            polygon: [
                { lat: -25.7521, lng: 28.1782 },
                { lat: -25.7488, lng: 28.1835 },
                { lat: -25.7449, lng: 28.1797 },
                { lat: -25.7478, lng: 28.1738 },
            ],
            markers: [{ lat: -25.7482, lng: 28.1789, label: "Sheep pen", kind: "poi" }],
            linkedWorkOrderIds: ["WO-0038"],
            linkedProjectIds: ["PRJ-002"],
        },
    ],
    equipment: [
        {
            id: "EQ-001",
            name: "JD-6130R Tractor",
            type: "Tractor",
            hoursRun: 3420,
            utilization: 78,
            fuelUsedL: 1250,
            lastService: "2026-03-10",
            nextService: "2026-04-10",
            status: "active",
            vehicleId: "v-301",
            operator: {
                name: "Johannes Moeletsi",
                role: "Field Operator",
                contact: "072 345 6789",
                email: "johannes@greenvalley.test",
                avatarInitials: "JM",
            },
            description: "Primary field tractor used for tillage, towing, and irrigation support tasks with full CAN-bus telemetry feed.",
            location: "North Field",
            fuelEfficiency: "18.5 L/hr",
            telemetry: [
                { label: "Engine temp", value: "87 C", helper: "Normal range", tone: "emerald" },
                { label: "Oil pressure", value: "42 psi", helper: "Live sensor", tone: "cyan" },
                { label: "Battery", value: "12.8 V", helper: "Healthy", tone: "emerald" },
            ],
            liveSignals: [
                { label: "Idle time", value: "11%", helper: "7-day avg", tone: "amber" },
                { label: "Coverage", value: "100%", helper: "Telematics uptime", tone: "emerald" },
                { label: "PTO use", value: "38%", helper: "Against workload", tone: "cyan" },
            ],
            maintenanceHistory: [
                {
                    id: "eq-001-main-1",
                    at: "2026-03-10",
                    title: "Oil change",
                    cost: 2500,
                    note: "Engine oil and filters replaced.",
                    owner: "Workshop",
                },
            ],
            alerts: [],
            timeline: [
                {
                    id: "eq-001-1",
                    at: "2026-03-20T07:50:00Z",
                    title: "Field shift started",
                    actorName: "Fleet telematics",
                    detail: "Machine entered north field route.",
                    tone: "cyan",
                },
            ],
            comments: [
                {
                    id: "eq-001-comment-1",
                    author: "Fleet Manager",
                    message: "Keep this asset on the irrigation backlog until the dam service plan closes.",
                    createdAt: "2026-03-18T10:00:00Z",
                    kind: "comment",
                },
            ],
            markers: [{ lat: -25.7444, lng: 28.1864, label: "Live tractor", kind: "vehicle" }],
        },
        {
            id: "EQ-004",
            name: "John Deere 5075E",
            type: "Utility Tractor",
            hoursRun: 1890,
            utilization: 55,
            fuelUsedL: 610,
            lastService: "2026-03-05",
            nextService: "2026-04-05",
            status: "maintenance",
            vehicleId: "v-307",
            operator: null,
            description: "Utility tractor temporarily held in workshop for transmission repair and post-repair validation.",
            location: "Workshop",
            fuelEfficiency: "16.8 L/hr",
            telemetry: [
                { label: "Battery", value: "11.9 V", helper: "Workshop charger connected", tone: "amber" },
                { label: "Engine runtime", value: "0 h", helper: "Repair mode", tone: "slate" },
                { label: "Fault code", value: "TRN-17", helper: "Transmission", tone: "rose" },
            ],
            liveSignals: [
                { label: "Downtime cost", value: "R 8 500", helper: "Current repair spend", tone: "rose" },
                { label: "Queue position", value: "1/3", helper: "Workshop jobs", tone: "violet" },
                { label: "Parts received", value: "Yes", helper: "Repair can continue", tone: "emerald" },
            ],
            maintenanceHistory: [
                {
                    id: "eq-004-main-1",
                    at: "2026-03-18",
                    title: "Transmission repair",
                    cost: 8500,
                    note: "Repair in progress.",
                    owner: "Workshop",
                },
            ],
            alerts: [
                {
                    id: "eq-004-alert-1",
                    title: "Workshop hold",
                    message: "Utility tractor unavailable pending transmission repair.",
                    severity: "critical",
                    createdAt: "2026-03-18T09:00:00Z",
                },
            ],
            timeline: [
                {
                    id: "eq-004-1",
                    at: "2026-03-18T09:00:00Z",
                    title: "Transmission repair opened",
                    actorName: "Workshop",
                    detail: "Machine removed from field duty and parked in bay 3.",
                    tone: "rose",
                },
            ],
            comments: [],
            markers: [{ lat: -25.749, lng: 28.187, label: "Workshop bay", kind: "poi" }],
        },
    ],
    geofences: [
        {
            id: "GEO-001",
            externalId: "cmmbx2da20004u3uwvtd3aqcz",
            name: "Test",
            type: "polygon",
            status: "active",
            area: "42.3 ha",
            perimeter: "2.8 km",
            owner: {
                name: "Jacob Mthembu",
                role: "Farm Manager",
                contact: "+27 82 555 1234",
                email: "jacob@greenvalley.test",
                avatarInitials: "JM",
                organization: "Green Valley Farm",
            },
            description: "Primary crop and herd geofence used for livestock movement, spray proof, and boundary-alert workflows.",
            alerts: [
                {
                    id: "geo-alert-001",
                    title: "Night entry detected",
                    message: "Machinery crossed the south edge at 21:14 for 7 minutes.",
                    severity: "warning",
                    createdAt: "2026-03-20T21:14:00Z",
                },
            ],
            zones: [
                { id: "geo-zone-1", name: "Crop Zone A", area: "18.2 ha", purpose: "Maize block" },
                { id: "geo-zone-2", name: "Crop Zone B", area: "24.1 ha", purpose: "Sunflower buffer" },
            ],
            notificationRules: [
                { id: "geo-rule-1", label: "Alert on machinery entry", enabled: true },
                { id: "geo-rule-2", label: "Alert on livestock exit", enabled: true },
            ],
            timeline: [
                {
                    id: "geo-001-1",
                    at: "2026-03-20T21:14:00Z",
                    title: "After-hours entry captured",
                    actorName: "Geofence engine",
                    detail: "South edge entry linked to a service vehicle event.",
                    tone: "amber",
                },
            ],
            comments: [
                {
                    id: "geo-001-comment-1",
                    author: "Precision Agriculture Desk",
                    message: "Keep this zone as the master template for the crop-plus-herd compliance workflow.",
                    createdAt: "2026-03-18T09:30:00Z",
                    kind: "comment",
                },
            ],
            polygon: [
                { lat: -25.748, lng: 28.216 },
                { lat: -25.742, lng: 28.222 },
                { lat: -25.738, lng: 28.214 },
                { lat: -25.744, lng: 28.208 },
            ],
            markers: [{ lat: -25.743, lng: 28.215, label: "Center", kind: "marker" }],
        },
        {
            id: "GEO-002",
            externalId: "geo-paddock-north-002",
            name: "North Paddock Boundary",
            type: "polygon",
            status: "active",
            area: "120 ha",
            perimeter: "4.7 km",
            owner: {
                name: "Thabo Ndlovu",
                role: "Farm Owner",
                contact: "+27 82 555 1234",
                avatarInitials: "TN",
            },
            description: "Livestock perimeter geofence for the North Paddock with after-hours gate monitoring and fence integrity workflows.",
            alerts: [],
            zones: [
                { id: "geo-zone-4", name: "North Fence", area: "4.7 km edge", purpose: "Fence integrity" },
            ],
            notificationRules: [
                { id: "geo-rule-4", label: "Fence break alert", enabled: true },
                { id: "geo-rule-5", label: "Curfew gate alert", enabled: true },
            ],
            timeline: [
                {
                    id: "geo-002-1",
                    at: "2026-03-20T22:14:00Z",
                    title: "Curfew gate event linked",
                    actorName: "Security Desk",
                    detail: "Escalated into fence maintenance planning.",
                    tone: "amber",
                },
            ],
            comments: [],
            polygon: [
                { lat: -25.744, lng: 28.188 },
                { lat: -25.74, lng: 28.193 },
                { lat: -25.736, lng: 28.1895 },
                { lat: -25.7386, lng: 28.1838 },
            ],
            markers: [{ lat: -25.7401, lng: 28.192, label: "North Gate", kind: "poi" }],
        },
    ],
    crops: [
        {
            id: "CRP-001",
            crop: "Maize",
            field: "Block A – North",
            area: 45,
            stage: "vegetative",
            planted: "2026-01-15",
            harvestEst: "2026-05-20",
            yieldEst: 6.2,
            pricePerTonne: 3450,
            status: "on-track",
            variety: "SC 701",
            fieldManager: {
                name: "Pieter van Wyk",
                role: "Crop Manager",
                contact: "+27 79 333 2200",
                email: "pieter@greenvalley.test",
                avatarInitials: "PW",
                organization: "Green Valley Farm",
            },
            description: "High-yield maize block tracked for emergence uniformity, spray windows, soil moisture, and market readiness.",
            healthMetrics: [
                { label: "NDVI", value: "0.78", helper: "Above target", tone: "emerald" },
                { label: "Soil moisture", value: "45%", helper: "North sensor cluster", tone: "cyan" },
                { label: "Canopy uniformity", value: "92%", helper: "Drone survey", tone: "emerald" },
            ],
            treatmentSummary: [
                { label: "Nitrogen applied", value: "150 kg/ha", helper: "Top dressing", tone: "cyan" },
                { label: "Herbicide window", value: "Closed", helper: "Post-emergence complete", tone: "emerald" },
                { label: "Irrigation plan", value: "6 mm/day", helper: "Current schedule", tone: "amber" },
            ],
            conditions: [
                {
                    id: "crop-cond-001",
                    at: "2026-03-18",
                    condition: "Healthy",
                    note: "No visible leaf stress; stand counts remain above threshold.",
                    owner: "Agronomy Team",
                },
            ],
            treatments: [
                {
                    id: "crop-trt-001",
                    at: "2026-03-06",
                    type: "Fertilizer",
                    product: "Nitrogen 46%",
                    rate: "150 kg/ha",
                    note: "Top dressing after rainfall event.",
                },
            ],
            harvestRecords: [
                {
                    id: "crop-harvest-001",
                    season: "2025",
                    yieldPerHa: "5.8 t/ha",
                    revenue: "R 899 000",
                    note: "Average rainfall year with lower fertilizer input.",
                },
            ],
            marketEntries: [
                {
                    id: "crop-market-001",
                    buyer: "GrainCorp SA",
                    initiative: "Farm-to-market forward contract",
                    quantity: "120 t",
                    price: "R 3 450/t",
                    status: "negotiating",
                    note: "Awaiting final moisture tolerance clause.",
                },
            ],
            images: [],
            timeline: [
                {
                    id: "crop-001-1",
                    at: "2026-03-18T10:30:00Z",
                    title: "Drone vigour scan completed",
                    actorName: "Field analytics",
                    detail: "NDVI improved 4 points over last flight.",
                    tone: "emerald",
                },
            ],
            comments: [
                {
                    id: "crop-001-comment-1",
                    author: "Market Desk",
                    message: "Forward contract demand remains strong for May delivery slots.",
                    createdAt: "2026-03-19T09:00:00Z",
                    kind: "comment",
                },
            ],
            polygon: [
                { lat: -25.7444, lng: 28.1851 },
                { lat: -25.742, lng: 28.1891 },
                { lat: -25.7397, lng: 28.1865 },
                { lat: -25.7417, lng: 28.1826 },
            ],
        },
        {
            id: "CRP-003",
            crop: "Potatoes",
            field: "Block E – Irrigated",
            area: 15,
            stage: "tuber-formation",
            planted: "2025-11-15",
            harvestEst: "2026-03-30",
            yieldEst: 35,
            pricePerTonne: 4500,
            status: "treatment",
            variety: "Mondial",
            fieldManager: {
                name: "Lebo Radebe",
                role: "Vegetable Unit Lead",
                contact: "+27 71 881 2245",
                email: "lebo@greenvalley.test",
                avatarInitials: "LR",
                organization: "Green Valley Farm",
            },
            description: "High-value irrigated potato block with disease scouting, tuber sizing, and market packing coordination.",
            healthMetrics: [
                { label: "Disease pressure", value: "Elevated", helper: "Late blight watch", tone: "amber" },
                { label: "Soil moisture", value: "62%", helper: "Above target after rainfall", tone: "violet" },
                { label: "Tuber sizing", value: "34 mm", helper: "Average sample size", tone: "cyan" },
            ],
            treatmentSummary: [
                { label: "Protective spray", value: "Scheduled", helper: "Within 24h", tone: "amber" },
                { label: "Cold chain prep", value: "Packing house booked", helper: "Market route confirmed", tone: "emerald" },
                { label: "Buyer slots", value: "2 active", helper: "Fresh market + processor", tone: "cyan" },
            ],
            conditions: [
                {
                    id: "crop-cond-201",
                    at: "2026-03-20",
                    condition: "Treatment",
                    note: "Protective fungicide pass required after rainfall spike.",
                    owner: "Lebo Radebe",
                },
            ],
            treatments: [
                {
                    id: "crop-trt-201",
                    at: "2026-03-21",
                    type: "Fungicide",
                    product: "Protective blight mix",
                    rate: "1.2 L/ha",
                    note: "Post-rain response program.",
                },
            ],
            harvestRecords: [
                {
                    id: "crop-harvest-201",
                    season: "2025",
                    yieldPerHa: "33 t/ha",
                    revenue: "R 2 227 500",
                    note: "Premium fresh market grade.",
                },
            ],
            marketEntries: [
                {
                    id: "crop-market-201",
                    buyer: "FreshLink",
                    initiative: "Farm-to-market cold chain",
                    quantity: "180 t",
                    price: "R 4 650/t",
                    status: "reserved",
                    note: "Packing calendar locked for week 13.",
                },
            ],
            images: [],
            timeline: [
                {
                    id: "crop-003-1",
                    at: "2026-03-20T15:20:00Z",
                    title: "Late blight watch escalated",
                    actorName: "Disease engine",
                    detail: "Rainfall and humidity triggered treatment workflow.",
                    tone: "amber",
                },
            ],
            comments: [
                {
                    id: "crop-003-comment-1",
                    author: "Packing House",
                    message: "Cold room 2 is reserved for this harvest week.",
                    createdAt: "2026-03-20T16:30:00Z",
                    kind: "comment",
                },
            ],
            polygon: [
                { lat: -25.7474, lng: 28.1885 },
                { lat: -25.7456, lng: 28.1915 },
                { lat: -25.7434, lng: 28.1891 },
                { lat: -25.7448, lng: 28.1859 },
            ],
        },
    ],
    pois: [
        {
            id: "POI-001",
            name: "Main Dam",
            type: "water-source",
            lat: -25.7461,
            lng: 28.1881,
            notes: "Primary irrigation supply with pump house, telemetry float sensor, and emergency overflow channel.",
            status: "active",
            owner: {
                name: "Irrigation Control Room",
                role: "Infrastructure Owner",
                contact: "+27 82 112 3344",
                email: "irrigation@greenvalley.test",
                avatarInitials: "IC",
            },
            images: [],
            linkedAssets: ["EQ-001", "CRP-003", "PRJ-003"],
            metrics: [
                { label: "Water level", value: "78%", helper: "Live float sensor", tone: "cyan" },
                { label: "Pump uptime", value: "99.2%", helper: "30-day average", tone: "emerald" },
            ],
            alerts: [
                {
                    id: "poi-alert-001",
                    title: "Pump house maintenance window",
                    message: "Routine service due in 5 days.",
                    severity: "warning",
                    createdAt: "2026-03-21T07:00:00Z",
                },
            ],
            history: [
                {
                    id: "poi-001-1",
                    at: "2026-03-18T09:00:00Z",
                    title: "Water quality sample passed",
                    actorName: "Water lab",
                    detail: "No contamination markers detected.",
                    tone: "emerald",
                },
            ],
            comments: [
                {
                    id: "poi-001-comment-1",
                    author: "Irrigation Supervisor",
                    message: "Confirm spare seal kit stock before the next service.",
                    createdAt: "2026-03-19T08:30:00Z",
                    kind: "comment",
                },
            ],
        },
        {
            id: "POI-003",
            name: "Grain Silo A",
            type: "storage",
            lat: -25.7485,
            lng: 28.1855,
            notes: "Maize storage silo with moisture probe and cleaning checklist integration.",
            status: "active",
            owner: {
                name: "Post Harvest Team",
                role: "Storage Owner",
                contact: "+27 72 008 4419",
                avatarInitials: "PH",
            },
            images: [],
            linkedAssets: ["WO-0037", "CRP-001"],
            metrics: [
                { label: "Fill level", value: "64%", helper: "Moisture safe", tone: "emerald" },
                { label: "Temperature", value: "18.6 C", helper: "Bin average", tone: "cyan" },
            ],
            alerts: [],
            history: [
                {
                    id: "poi-003-1",
                    at: "2026-03-05T15:00:00Z",
                    title: "Cleaning cycle closed",
                    actorName: "Work order WO-0037",
                    detail: "Inspection passed and silo returned to service.",
                    tone: "emerald",
                },
            ],
            comments: [],
        },
    ],
    workOrders: [
        {
            id: "WO-0041",
            title: "Irrigation line repair – Block E",
            description: "Damaged drip irrigation coupling on Row 14-18 in Block E. Water pressure dropped 40% and potatoes are at moisture risk.",
            assignee: "Johannes Moeletsi",
            assigneeId: "FW-001",
            vehicleId: "v-301",
            vehicle: "JD-6130R Tractor",
            priority: "high",
            status: "in-progress",
            startDate: "2026-03-06",
            dueDate: "2026-03-08",
            endDate: "",
            projectId: "PRJ-003",
            geofence: "Block E – Irrigated",
            geofenceArea: 15,
            geofenceShape: "polygon",
            geo: { lat: -25.7461, lng: 28.1881 },
            workers: ["FW-001"],
            tasks: [
                { t: "Inspect damaged line", done: true },
                { t: "Replace coupling", done: false },
                { t: "Pressure test", done: false },
            ],
            attachments: [
                { name: "damaged_pipe.jpg", type: "image", size: "2.1 MB", date: "2026-03-06" },
            ],
            activity: [
                { action: "Created", by: "Pieter van Wyk", date: "2026-03-06T08:00:00Z" },
                { action: "Status → in-progress", by: "FW-001", date: "2026-03-06T09:30:00Z" },
            ],
            category: "Infrastructure",
            budget: 28000,
            estimatedHours: 18,
            actualHours: 9,
            livestockIds: [],
            equipmentIds: ["EQ-001"],
            poiIds: ["POI-001"],
            materials: ["Drip couplings", "Seal kit", "Pressure gauge", "Repair clamp"],
            comments: [
                {
                    id: "wo-0041-comment-1",
                    author: "Irrigation Desk",
                    message: "Prioritise pressure test before the evening irrigation cycle.",
                    createdAt: "2026-03-06T12:15:00Z",
                    kind: "comment",
                },
            ],
        },
        {
            id: "WO-0038",
            title: "Livestock vaccination – South herd",
            description: "Administer Clostridial vaccine to all Merino sheep. Record batch numbers, wastage, and post-dose observation notes.",
            assignee: "Grace Mahlangu",
            assigneeId: "FW-002",
            vehicleId: "v-304",
            vehicle: "Vet Vehicle",
            priority: "urgent",
            status: "scheduled",
            startDate: "",
            dueDate: "2026-03-22",
            endDate: "",
            projectId: "PRJ-002",
            geofence: "South Field",
            geofenceArea: 85,
            geofenceShape: "polygon",
            geo: { lat: -25.747, lng: 28.189 },
            workers: ["FW-002"],
            tasks: [
                { t: "Prepare vaccines", done: false },
                { t: "Gather sheep", done: false },
                { t: "Administer doses", done: false },
                { t: "Record batch numbers", done: false },
            ],
            attachments: [],
            activity: [{ action: "Created", by: "Farm Manager", date: "2026-03-06T12:00:00Z" }],
            category: "Animal health",
            budget: 9600,
            estimatedHours: 8,
            actualHours: 0,
            livestockIds: ["HRD-003"],
            equipmentIds: [],
            poiIds: ["POI-001"],
            materials: ["Clostridial vaccine", "Syringes", "Ice box"],
            comments: [],
        },
    ],
    projects: [
        {
            id: "PRJ-002",
            name: "Livestock Health Program",
            description: "Quarterly livestock care initiative covering vaccinations, paddock security, telematics compliance, and welfare controls.",
            manager: "Grace Mahlangu",
            managerId: "FW-002",
            status: "active",
            startDate: "2026-01-15",
            endDate: "2026-06-30",
            budget: 95000,
            spent: 28000,
            woIds: ["WO-0038"],
            coordinates: { lat: -25.742, lng: 28.189 },
            type: "Livestock health",
            objectives: [
                "Complete vaccination cycles for all active herds",
                "Reduce avoidable fence and gate incidents",
            ],
            milestones: [
                { id: "proj-002-ms-2", title: "South herd vaccinated", status: "pending", dueDate: "2026-03-22" },
            ],
            risks: [
                {
                    id: "proj-002-risk-1",
                    title: "Delayed vaccination window",
                    severity: "high",
                    mitigation: "Reserve herd labour, vet stock, and crush-pen slots early.",
                },
            ],
            comments: [],
            timeline: [
                {
                    id: "proj-002-1",
                    at: "2026-03-21T04:00:00Z",
                    title: "Vaccination schedule triggered",
                    actorName: "Animal health engine",
                    detail: "South flock moved onto urgent preparation queue.",
                    tone: "amber",
                },
            ],
        },
        {
            id: "PRJ-003",
            name: "Infrastructure Maintenance",
            description: "Scheduled maintenance on boreholes, pumps, silo assets, and irrigation infrastructure with telematics-linked proof of service.",
            manager: "Johannes Moeletsi",
            managerId: "FW-001",
            status: "planning",
            startDate: "2026-03-01",
            endDate: "2026-08-31",
            budget: 250000,
            spent: 67000,
            woIds: ["WO-0041"],
            coordinates: { lat: -25.7461, lng: 28.1881 },
            type: "Infrastructure",
            objectives: [
                "Stabilise irrigation uptime above 99%",
                "Maintain storage assets in export-ready condition",
            ],
            milestones: [
                { id: "proj-003-ms-1", title: "Dam service plan approved", status: "done", dueDate: "2026-03-05" },
            ],
            risks: [
                {
                    id: "proj-003-risk-1",
                    title: "Pump seal lead time",
                    severity: "medium",
                    mitigation: "Keep two seal kits in local workshop stock.",
                },
            ],
            comments: [],
            timeline: [
                {
                    id: "proj-003-1",
                    at: "2026-03-18T11:15:00Z",
                    title: "Supplier framework drafted",
                    actorName: "Workshop Planner",
                    detail: "Long-lead maintenance consumables moved into blanket order proposal.",
                    tone: "violet",
                },
            ],
        },
    ],
    workers: [
        {
            id: "FW-001",
            name: "Johannes Moeletsi",
            role: "Field Operator",
            contact: "072 345 6789",
            availability: "available",
            assignedWOs: ["WO-0041"],
            skills: ["Tractor operation", "Spraying", "Irrigation"],
            hourlyRate: 45,
            joined: "2024-02-15",
            photoUrl: null,
            passportNumber: "M3487729",
            nationalId: "8001015084089",
            dateOfBirth: "1980-01-01",
            address: "Plot 45, Green Valley Farm, Limpopo",
            emergencyContact: "Maria Moeletsi · 071 234 5678",
            employmentType: "Permanent",
            department: "Field Operations",
            supervisor: "Pieter van Wyk",
            notes: "Reliable machinery operator trusted on treatment windows and emergency irrigation jobs.",
            qualifications: ["Tractor license", "Pesticide handling"],
            certifications: [
                { id: "fw-001-cert-1", name: "Tractor Operator", issuedAt: "2024-01-15", expiresAt: "2027-01-15" },
            ],
            trainingRecords: [
                { id: "fw-001-trn-1", topic: "Precision Agriculture", provider: "AgriCollege", completedAt: "2025-02-10" },
            ],
            comments: [
                {
                    id: "fw-001-comment-1",
                    author: "Supervisor",
                    message: "Excellent machine care and job completion quality.",
                    createdAt: "2026-03-15T08:00:00Z",
                    kind: "comment",
                },
            ],
            timeline: [
                {
                    id: "fw-001-1",
                    at: "2026-03-15T08:00:00Z",
                    title: "Performance note added",
                    actorName: "Supervisor",
                    detail: "Recognised for consistent completion quality.",
                    tone: "emerald",
                },
            ],
        },
        {
            id: "FW-002",
            name: "Grace Mahlangu",
            role: "Livestock Handler",
            contact: "083 456 7890",
            availability: "busy",
            assignedWOs: ["WO-0038"],
            skills: ["Animal handling", "Fencing", "Vaccination assist"],
            hourlyRate: 40,
            joined: "2023-08-01",
            photoUrl: null,
            passportNumber: "P1197741",
            nationalId: "8605050067087",
            dateOfBirth: "1986-05-05",
            address: "Workers Village House 11",
            emergencyContact: "Jonas Mahlangu · 082 555 0901",
            employmentType: "Permanent",
            department: "Livestock Operations",
            supervisor: "Nomsa Dlamini",
            notes: "Key herd-movement coordinator and crush-pen setup lead.",
            qualifications: ["Animal welfare induction", "Fence maintenance"],
            certifications: [
                { id: "fw-002-cert-1", name: "Animal Welfare", issuedAt: "2024-05-10", expiresAt: "2027-05-10" },
            ],
            trainingRecords: [
                { id: "fw-002-trn-1", topic: "Vaccination Handling", provider: "Vet Services", completedAt: "2025-01-20" },
            ],
            comments: [],
            timeline: [
                {
                    id: "fw-002-1",
                    at: "2026-03-21T04:10:00Z",
                    title: "Vaccination task assigned",
                    actorName: "Animal health engine",
                    detail: "South flock work order added to active queue.",
                    tone: "amber",
                },
            ],
        },
    ],
    timesheets: [
        { id: "TS-101", workerId: "FW-001", date: "2026-03-06", hours: 8.5, woId: "WO-0041", status: "approved" },
        { id: "TS-104", workerId: "FW-002", date: "2026-03-20", hours: 7.5, woId: "WO-0038", status: "pending" },
    ],
    reports: [
        {
            id: "farm-telematics",
            name: "Farm Telematics",
            description: "Boundary events, live sensors, route adherence, and machine proof of work.",
            reports: [
                {
                    id: "farm-report-001",
                    name: "Livestock movement variance",
                    description: "Compares expected herd routes against actual tracker movement and fence compliance.",
                    module: "Livestock",
                    delivery: "preview",
                    tags: ["tracker", "geofence", "animal health"],
                    fields: ["Herd", "Movement variance", "Boundary events", "Average distance", "Compliance"],
                    previewRows: [
                        { Herd: "HRD-001", "Movement variance": "3.2%", "Boundary events": 1, "Average distance": "8.4 km", Compliance: "99.1%" },
                        { Herd: "HRD-003", "Movement variance": "1.8%", "Boundary events": 0, "Average distance": "6.1 km", Compliance: "98.7%" },
                    ],
                },
            ],
        },
        {
            id: "farm-crops",
            name: "Crop and Market",
            description: "Yield, treatment, harvest, and farm-to-market readiness.",
            reports: [
                {
                    id: "farm-report-005",
                    name: "Yield and revenue forecast",
                    description: "Forecasted tonnage and revenue by active crop block using current market prices.",
                    module: "Crops",
                    delivery: "preview",
                    tags: ["yield", "revenue", "forecast"],
                    fields: ["Crop", "Field", "Forecast yield", "Price/t", "Projected revenue"],
                    previewRows: [
                        { Crop: "Maize", Field: "Block A – North", "Forecast yield": "6.2 t/ha", "Price/t": "R 3 450", "Projected revenue": "R 962 550" },
                        { Crop: "Potatoes", Field: "Block E – Irrigated", "Forecast yield": "35 t/ha", "Price/t": "R 4 500", "Projected revenue": "R 2 362 500" },
                    ],
                },
            ],
        },
        {
            id: "farm-workforce",
            name: "Workforce and HR",
            description: "Skills, availability, timesheets, and linked project exposure.",
            reports: [
                {
                    id: "farm-report-009",
                    name: "Worker productivity and pay",
                    description: "Timesheet hours, assigned work orders, and estimated payroll exposure.",
                    module: "Farm Workers",
                    delivery: "preview",
                    tags: ["hr", "timesheets", "productivity"],
                    fields: ["Worker", "Availability", "Hours", "Assigned WOs", "Estimated pay"],
                    previewRows: [
                        { Worker: "Johannes Moeletsi", Availability: "Available", Hours: "8.5", "Assigned WOs": 1, "Estimated pay": "R 383" },
                        { Worker: "Grace Mahlangu", Availability: "Busy", Hours: "7.5", "Assigned WOs": 1, "Estimated pay": "R 300" },
                    ],
                },
            ],
        },
    ],
    weather: {
        temp: 28,
        condition: "Sunny",
        humidity: 42,
        windSpeed: 12,
        windDir: "NE",
        rainfall24h: 0,
        forecast: [
            { day: "Mon", temp: 29, icon: "SUN" },
            { day: "Tue", temp: 26, icon: "PARTLY" },
            { day: "Wed", temp: 22, icon: "RAIN" },
        ],
        soilMoisture: [
            { block: "Block A", val: 45, status: "optimal" },
            { block: "Block E", val: 62, status: "wet" },
        ],
    },
};
